import type { NextPage } from "next";
import Head from "next/head";
import PrivacyPolicy from "../Components/PrivacyPolicy";
import "../i18n";

const PrivacyPolicies: NextPage = () => {
  return (
    <div>
      <Head>
        <title>Excel Technologies - Chính sách bảo mật</title>
      </Head>
      <PrivacyPolicy />
    </div>
  );
};

export default PrivacyPolicies;
